import {
  Button,
  Grid,
  MenuItem,
  Select,
  TextField,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Checkbox,
  Tooltip
} from "@material-ui/core";
import { UserFile } from "../../../models/UserFile";
import React, { useEffect, useState } from "react";
import useStyles from "./VendorDetail.css";
import translation from "../../../i18n/i18.json";
import { VendorMasterData } from "../../../services/VendorMasterData";
import {
  VendorDetailState,
  MillEvaluationFormDetail
} from "../../../reducers/vendor/VendorDetailReducer";
import { useSelector } from "react-redux";
import { RootState } from "../../../reducers";
import AllActions from "../../../actions";
import { useDispatch } from "react-redux";
import HighlightOffOutlinedIcon from "@material-ui/icons/HighlightOffOutlined";
import { InforDisplyaDuration, FileUploadTypes } from "../../../constants/AppConstants";
import FileUpload from "../../../components/FileUpload/FileUpload";
import SingleFileDownload from "../../../components/SingleFileDownload/SingleFileDownload";
import FileDownload from "../../../components/FileDownload/FileDownload";
import { Attachment } from "../../../models/Attachment";
import { FileUploadResponse } from "../../../models/FileUploadResponse";
import { ResponseObject } from "../../../models/ResponseObject";

export default function MillEvaluationForm(props: any) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const {
    isEditableMode,
    //uomData,
  } = props;

  const vendorDetail: VendorDetailState = useSelector<
    RootState,
    VendorDetailState
  >((state) => state.vendorDetails);


  const [tableData, setTableData] = useState<MillEvaluationFormDetail[]>([]);
  const [openAttchmentsDialog, setOpenAttchmentsDialog] = useState(false);
  const [attachments, setAttachments] = useState<Attachment[]>([]);

  const tableColumnData = [
    { name: translation.vendor_detail_millevaluationform_millevaluation_lbl },
    { name: translation.vendor_detail_millevaluationform_RmCategory_lbl },
    { name: translation.vendor_detail_millevaluationform_download_lbl },
    { name: translation.vendor_detail_millevaluationform_upload_lbl },
    { name: translation.vendor_detail_millevaluationform_rating_lbl }
  ];

  useEffect(() => {
    if (vendorDetail.millEvaluationFormList) {
      if(vendorDetail.millEvaluationFormList.length>0)
      {
        vendorDetail.millEvaluationFormList.forEach(element => {
          if(element.downloadFile!=null && element.uploadFile==null)
          {
            element.uploadFile= { fileId: 0, fileName: "", filePath: "" }
          }
        });
      }
      setTableData(vendorDetail.millEvaluationFormList);
    }
  }, [vendorDetail.millEvaluationFormList]);

  const handleMillEvaluationUpload = (fileUploadData: FileUploadResponse, row: MillEvaluationFormDetail) => {
    if(fileUploadData && fileUploadData.result){
      if(fileUploadData.errors && fileUploadData.errors.length > 0) {
        //show errors
      } else {
        row.rating = fileUploadData.result.weightedRatingPerc as number;
        //TODO refresh
        setTableData([...tableData]);

      }
    }
  }
  //   setTableData(updatedList);

  //   dispatch(
  //     AllActions.vendorDetailActions.updateDataField(
  //       "millEvaluationFormList",
  //       updatedList
  //     )
  //   );
  // };

  return (
    <div>
      <Grid container spacing={2} item xs={12} sm={12} md={11} lg={12}>

        <Grid container spacing={2} item xs={12} sm={12} md={11} lg={12}>
          <div className={classes.tblOuterBG} style={{ width: "100%" }}>
            <Paper>
              <TableContainer className={classes.tblContainer}>
                <Table
                  size="small"
                  stickyHeader
                  aria-label="sticky table"
                  style={{ minWidth: "100px" }}
                >
                  <TableHead className={classes.tblHeader}>
                    <TableRow>
                      {tableColumnData.map((column, index) => {
                        if (!isEditableMode) {
                          if (column.name != translation.vendor_detail_millevaluationform_download_lbl) {
                            return (
                              <TableCell style={{ minWidth: "100px" }}>
                                {column.name}
                              </TableCell>
                            );
                          }
                        }
                        else {
                          return (
                            <TableCell style={{ minWidth: "100px" }}>
                              {column.name}
                            </TableCell>
                          );
                        }
                      })}
                      {<TableCell style={{ minWidth: "79px" }}></TableCell>}

                    </TableRow>
                  </TableHead>
                  {(isEditableMode || tableData.filter(x => x.uploadFile == null).length != tableData.length) && <TableBody className={classes.tblBody}>
                    {tableData &&
                      tableData.map((row, i) => {
                        return (
                          <TableRow key={row.id}>
                            <TableCell>
                              {row.millEvaluationName}
                            </TableCell>
                            <TableCell>
                              {row.rmCategoryName}
                            </TableCell>
                            {isEditableMode && <TableCell>
                              <Grid item xs={12} sm={12} md={6} lg={4} >
                                <Grid className={classes.formOneinputWrapper} item xs={12} sm={12} md={12} lg={12} >
                                  <div className={classes.fileWrapper} style={{ width: "140%" }}>
                                    {/*  <FileDownload
                                      open={true}
                                      setOpen={false}
                                      files={attachments}
                                    ></FileDownload> */}
                                    <SingleFileDownload
                                      editable={false}
                                      requestNumber={vendorDetail.RequestNumber}
                                      userfile={row.downloadFile}
                                      attachmentType={row.uploadTypeId}
                                      id={""}
                                    ></SingleFileDownload>
                                  </div>

                                </Grid>
                              </Grid>
                            </TableCell>
                            }
                            <TableCell>
                              <Grid item xs={12} sm={12} md={6} lg={4} >
                                <Grid className={classes.formOneinputWrapper} item xs={12} sm={12} md={12} lg={12} >
                                  <div className={classes.fileWrapper} style={{ width: "300%" }}>
                                    <FileUpload
                                      editable={isEditableMode}
                                      requestNumber={vendorDetail.RequestNumber}
                                      userfile={row.uploadFile}
                                      attachmentType={row.uploadTypeId}
                                      acceptTypes=".xlsx"
                                      onFileUpload={ (uploadResponse: FileUploadResponse) => { handleMillEvaluationUpload(uploadResponse, row); } }
                                    />
                                  </div>
                                </Grid>
                              </Grid>
                            </TableCell>
                            <TableCell>
                              {row.rating ? row.rating.toFixed(2) : 0}
                            </TableCell>
                          </TableRow>
                        );
                      })}
                  </TableBody>
                  }
                </Table>
              </TableContainer>

            </Paper>
          </div>
        </Grid>
      </Grid>


    </div>
  );
}
